import Raven from 'raven-js';

if (ENV !== 'local' && ENV !== 'demo' && SENTRY_DSN){

    Raven.config(SENTRY_DSN, {
        release: APP_VERSION,
        collectWindowErrors: true
    }).install();
}
else {

    console.warn('SENTRY client was not initialized');
}



// WEBPACK FOOTER //
// ./js/sentry.js